




import type { PropType } from '@nuxtjs/composition-api';
// eslint-disable-next-line no-duplicate-imports
import { defineComponent } from '@nuxtjs/composition-api';

import { useNostoCategory } from '~/diptyqueTheme/composable/nosto/useNostoCategory';
import { useNostoStore } from '~/diptyqueTheme/stores/nosto';

export default defineComponent({
  name: 'NostoCategory',
  props: {
    category: {
      type: String as PropType<string>,
      required: true
    }
  },
  setup(props) {
    const { setCategoryId } = useNostoStore();

    useNostoCategory(props.category);
    setCategoryId(props.category);
  }
});
